import MoneyNoteColor from './MoneyNoteColour.svg';
import MoneyNoteDark from './MoneyNoteDark.svg';
import MoneyNoteLight from './MoneyNoteLight.svg';
export const moneyNote = {
    color: MoneyNoteColor,
    dark: MoneyNoteDark,
    light: MoneyNoteLight
};
//# sourceMappingURL=index.js.map